'use strict'
/**
 * landedReading.js — Contrato LandedReading (MACRO 1 · Ola 2).
 *
 * El output del neopreno (BLUEPRINT B.3): INTERPRETER(activity,
 * physiology, goal) → LandedReading. La honestidad #10 viaja en el
 * tipo: confidence + kb_refs + reliability son parte del contrato,
 * no decoración.
 *
 * PRODUCTOR: src/prime-sense/neoprene/interpreter.js · interpret()
 * CONSUMIDOR: hubCore (analyzeWorkoutV2) → _bridgeNeopreneToUI → HUB UI
 *
 * Tiene 3 variantes legítimas: lectura completa · _error (ingesta
 * inválida) · _disabled (kill-switch NEOPRENE_ENABLED=false).
 */

const { z } = require('./z')

const KbRefs = z.array(z.string())

const RelativeEffortSchema = z
  .object({
    value: z.string(),                                      // recovery|easy|moderate|hard|max|below_z1
    zone: z.number().nullable().optional(),
    rationale: z.string().optional().nullable(),
    confidence: z.string().optional().nullable(),
    kb_refs: KbRefs.optional(),
    srpe: z.number().nullable().optional(),                 // vía D13 intermitente
  })
  .passthrough()

const RecoverySchema = z
  .object({
    cost: z.string(),                                       // low|moderate|high…
    estimated_ready_in_h: z.number().nullable().optional(), // null si no hay datos fiables (honesto)
    based_on: z.unknown().optional(),
    caveat: z.string().nullable().optional(),
    reliability: z.unknown().optional(),
    kb_refs: KbRefs.optional(),
  })
  .passthrough()

const GoalFitSchema = z
  .object({
    alignment: z.string().nullable(),
    rationale: z.string().nullable().optional(),
    kb_refs: KbRefs.optional(),
  })
  .passthrough()

/** Lectura completa (el caso normal). */
const LandedReadingFullSchema = z
  .object({
    relative_effort: RelativeEffortSchema,
    load: z
      .object({
        cardiovascular: z.unknown().optional(),             // trimpResult (shape del TRIMP engine)
        muscular_groups: z.unknown().optional(),
        kb_refs: KbRefs.optional(),
      })
      .passthrough(),
    recovery: RecoverySchema,
    goal_fit: GoalFitSchema,
    // Honestidad transversal (#10) — obligatoria en el contrato
    overall_confidence: z.string(),
    reliability_note: z.string().optional().nullable(),
    // Metadatos de calibración (PRIME TRUTH)
    _schema_name: z.literal('LandedReading').optional(),
    _calibration_status: z.string().optional(),
    _required_specialty: z.string().optional(),
  })
  .passthrough()

/** Variante error de ingesta — honesta, no un crash. */
const LandedReadingErrorSchema = z
  .object({
    _schema_name: z.literal('LandedReading'),
    _error: z.object({ code: z.string(), message: z.string() }).passthrough(),
  })
  .passthrough()

/** Variante kill-switch. */
const LandedReadingDisabledSchema = z
  .object({
    _schema_name: z.literal('LandedReading'),
    _disabled: z.literal(true),
  })
  .passthrough()

const LandedReadingSchema = z.union([
  LandedReadingErrorSchema,
  LandedReadingDisabledSchema,
  LandedReadingFullSchema,
])

module.exports = {
  LandedReadingSchema,
  LandedReadingFullSchema,
  LandedReadingErrorSchema,
  LandedReadingDisabledSchema,
}
